import { AddClientStoreStatic } from "./AddClientStoreStatic";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { Dispatcher } from "../../../../../../react-core/Flux/Dispatcher";
import { CustomerMatchingStoreStatic } from "./CustomerMatchingStoreStatic";

export interface FluxResponse {
    actionType: ActionType;
    isLoading?: boolean;
    payload?: any;
    otherObj?: any;
}

export const AddClientDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const AddClientStore: AddClientStoreStatic = new AddClientStoreStatic();

export const CustomerMatchingDispatcher: Dispatcher<FluxResponse> = new Dispatcher<FluxResponse>();
export const CustomerMatchingStore: CustomerMatchingStoreStatic = new CustomerMatchingStoreStatic();
